import { render, staticRenderFns } from "./CompanyDesktopTakenMeals.vue?vue&type=template&id=db5dc84c"
import script from "./CompanyDesktopTakenMeals.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopTakenMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports